import { useEffect } from "react";
import { useSelector } from "react-redux";
import GlobalLoader from "./GlobalLoader";

export function LoaderWrap({ children }) {
  const slices = [
    useSelector((state) => state.page),
    useSelector((state) => state.homePage),
    useSelector((state) => state.brands),
    useSelector((state) => state.recipes),
    useSelector((state) => state.career),
    useSelector((state) => state.contact),
    useSelector((state) => state.footer),
    useSelector((state) => state.jobForm),
  ];

  const isLoading = slices.some((slice) => slice.loading);
  const hasError = slices.some((slice) => slice.error);

  useEffect(() => {
    if (!isLoading) {
      window.scrollTo(0, 0);
    }
  }, [isLoading]);

  if (isLoading) return <GlobalLoader />;

  if (!isLoading && hasError) {
    return (
      <div className="ErrorLoadApi TGLo64PxPC">
        <div>Something went wrong!</div>
        <div>
          <button onClick={() => window.location.reload()} className="FromWsubmitB ar TFut16PxPCUC">
            Please Reload
          </button>
        </div>
      </div>
    );
  }

  return children;
}
